<nav class="navbar navbar-expand px-3 border-bottom">
  <button
    class="btn"
    id="sidebar-toggle"
    type="button"
    (click)="toggleSidebar()"
    aria-label="Toggle sidebar"
  >
    <i class="fa-solid fa-bars"></i>
  </button>
  <div class="navbar-collapse navbar">
    <ul class="navbar-nav ms-auto">
      <li class="nav-item d-flex align-items-center me-3">
        <app-notification-bell></app-notification-bell>
      </li>
      <li class="nav-item">
        <app-profile></app-profile>
      </li>
    </ul>
  </div>
</nav>
